<template>
  <div class="product-list-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to Ani Groups</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="first button-container">
          <primary-button @click.native="uploadFile" class="button">Import</primary-button>
        </div>
      </div>
    </nav>
    <div class="table table-header">
      <div class="first">
        <primary-input
          type="text"
          name="ani group name"
          class="field"
          v-model="ani_group_name"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('ani group name')}"
          placeholder="Enter ani group name"
        />
        <div
          class="help is-danger"
          v-if="errors.has('ani group name')"
        >{{ errors.first('ani group name') }}</div>
        <div class="upload-container">
          <app-dropzone
            @fileAdd="fileAdded($event)"
            @remove="fileRemoved($event)"
            class="dimension"
            name="file"
            v-model="file"
            v-validate="'required'"/>
        </div>
        <div class="help is-danger" v-if="errors.has('file')">{{ errors.first('file') }}</div>
      </div>
      <!-- <div class="second">Second Name</div>
      <div class="third">Phone number</div>
      <div class="fourth">Address</div>
      <div class="fifth">add</div>-->
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton"),
    AppDropzone: () => import("@/components/Dropzone")
  },
  data: () => ({
    file: null,
    aniGroupError: [],
    ani_group_name: null
  }),
  methods: {
    fileAdded(file) {
      console.log(file);
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
     fileRemoved() {
      this.file = null;
    },
    uploadFile: async function() {
      const valid = await this.$validator.validate();

      if (valid) {
        let data = new FormData();

        data.append("file", this.file);
        data.append("type", "application/vnd.ms-excel");
        data.append(
          "company_uuid",
          this.$store.getters.getCompany.company_uuid
        );
        // data.append('did_auto_create', true);
        data.append("duplicates_action", "override");
        data.append("ani_group_name", this.ani_group_name); // suphal123

        try {
          await this.$store.dispatch("UploadFile", data);

          this.$snotify.success("ANI Group file imported.", {
            timeout: 6000
          });

          this.$router.push({ name: "company-admin-campaings-ani-groups" });
        } catch (err) {
          if (err.errors) {
            this.aniGroupError = err.errors[0].aniGroup
              ? err.errors[0].aniGroup
              : null;
            setTimeout(() => {
              this.aniGroupError = null;
            }, 6000);
          } else {
            console.log("err.response.data", err.response.data);
            if(err.response.data.error) {
                this.$snotify.error(err.response.data.error.message, {
                timeout: 6000
              });
            } else {
              this.$snotify.error(err.response.data.errors, {
                timeout: 6000
              });
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list-container {
  padding: 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      .button {
        height: 40px;
        width: 130px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .table {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 410px;
    padding-right: 20px;
    box-sizing: border-box;
    justify-content: space-between;
    .first {
      min-width: fit-content;
      width: calc(20% - 7.5px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .field {
        margin-bottom: 5px;
      }
      .upload-container {
        height: 300px;
        width: 350px;
        margin-bottom: 5px;
        #dropzone {
          height: 300px;
          img {
            width: 300px;
            height: 260px;
          }
          .dz-details {
            width: 300px;
            height: 260px;
          }
          .dz-remove {
            width: 270px;
            height: 240px;
            margin-top: 15px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>

